import React from 'react';

const QuestionId = ({id}) => (
    <>
        <span className="question-id">{id}</span>
    </>
);

export default QuestionId;
